module.exports = __webpack_public_path__ + "img/eye.07e3bbcd.svg";